<template>
  <div class="search-results-container">
    <template v-if="isEmptySearchObject">
      <div v-if="searchObject.loading">
        <search-loader-container :search-result="searchObject.searchResult" />
      </div>
      <div v-else>
        <title-with-message
          title="No properties found"
          message="There are no properties for the above selected inputs. Please try searching for another entry."
          :content-small="true"
        />
      </div>
    </template>
    <template v-else>
      <results-layout
        :search-object="searchObject"
        :assign-to-client="assignToClient"
        @open-display-property="$emit('open-display-property', $event)"
      />
      <loader-button
        v-if="hasMoreSearches && hideMap"
        :loading="searchObject.loading"
        :disabled="searchObject.loading"
        btn-text="Load More"
        btn-class="btn-load-more"
        @handle-button-click="$emit('load-more-clicked')"
      />
      <div v-if="searchObject.loading">
        <search-loader-container :search-result="searchObject.searchResult" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchLoaderContainer from '../common/search/SearchLoaderContainer.vue'
import TitleWithMessage from '../uiUtils/TitleWithMessage.vue'
import ResultsLayout from './ResultsLayout.vue'
import LoaderButton from '../uiUtils/LoaderButton.vue'
import { isEmpty } from '../../utils/generalUtils'

export default {
  components: {
    SearchLoaderContainer,
    TitleWithMessage,
    ResultsLayout,
    LoaderButton
  },
  filters: {
    commaSeparated(val) {
      return (val || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  props: {
    assignToClient: {
      type: Object,
      default: () => ({})
    },
    searchObject: {
      type: Object,
      required: true
    },
    hasMoreSearches: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState('common', ['isMobile']),
    ...mapState('agent', ['agentData', 'hideMap']),

    isEmptySearchObject() {
      return this.searchObject && isEmpty(this.searchObject.data)
    }
  }
}
</script>

<style lang="sass" scoped>
.search-results-container
  overflow: auto

#searchQueryLayout
  background-color: $hwayzF8
  padding: 2rem

#moreOptionsLayout
  padding: 15px 100px 25px 100px
  background-color: $hwayzF8

#searchAndSortLayout
  padding: 15px 90px
  background-color: $hwayzec

.search-container__input
  width: 100%
  padding: 0 12px
  height: 42px
  background: white
  border-left: $hwayzLightGray 1px solid !important
  outline: none
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), lang="sass" 0 1px 5px 0 rgba(0, 0, 0, 0.12)

.label-link
  text-transform: uppercase
  cursor: pointer
  font-size: 16px

.select-field-label
  text-align: left
  color: $hwayzBlack
  font-size: 16px
  margin-bottom: 10px

.menu-item
  margin: 0 -5px 0 -5px
  padding: 2px 5px 2px 5px
  border: transparent 2px solid

.menu-item-selected
  border: $hwayzBlack 2px solid !important
  color: $hwayzBlack

.my-spacer
  width: 1px

#searchButton
  width: 100%
  margin: 0
  border-radius: 0px
  height: 42px
  font-size: 18px
  font-weight: bold !important
  text-transform: capitalize

</style>
